import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PlantsNetworkState, PlantNetworkStatus } from './plant-network-status.models';

// Selector to get the entire plant-network-status state
export const selectPlantNetworkState = createFeatureSelector<PlantsNetworkState>('plantNetworkStatus');

// Selector to get all plants
export const selectAllPlants = createSelector(selectPlantNetworkState, (state) => state.plants);

// Selector to get a specific plant by its code
export const selectPlantByCode = (plantCode: string) =>
  createSelector(selectAllPlants, (plants) => plants.get(plantCode) || null);

// Selector to get a specific plant by its code
export const selectPlanstByCodes = (plantCode: string[]) =>
  createSelector(selectAllPlants, (plants) => plantCode.map((code) => plants.get(code)) || null);

// Selector to check if a plant is online
export const selectIsPlantOnline = (plantCode: string) =>
  createSelector(selectPlantByCode(plantCode), (plant) => plant?.IsOnline || false);

// Selector to get all online plants
export const selectOnlinePlants = createSelector(selectAllPlants, (plants) => {
  const result: PlantNetworkStatus[] = [];
  plants.forEach((plant) => {
    if (plant.IsOnline) {
      result.push(plant);
    }
  });
  return result;
});

// Selector to get all offline plants
export const selectOfflinePlants = createSelector(selectAllPlants, (plants) => {
  const result: PlantNetworkStatus[] = [];
  plants.forEach((plant) => {
    if (!plant.IsOnline) {
      result.push(plant);
    }
  });
  return result;
});

// Selector to get the current date
export const selectCurrentDate = createSelector(selectPlantNetworkState, (state) => state.currentDate);

// Selector to get loading state
export const selectIsLoading = createSelector(selectPlantNetworkState, (state) => state.isLoading);

// Selector to get error state
export const selectError = createSelector(selectPlantNetworkState, (state) => state.error);

// Selector to get plant statistics: total plants, online and offline
export const selectPlantStatistics = createSelector(selectAllPlants, (plants) => {
  let totalOnline = 0;
  let totalOffline = 0;

  plants.forEach((plant) => {
    if (plant.IsOnline) {
      totalOnline++;
    } else {
      totalOffline++;
    }
  });

  return {
    total: plants.size,
    online: totalOnline,
    offline: totalOffline,
    percentageOnline: plants.size > 0 ? (totalOnline / plants.size) * 100 : 0,
  };
});
